// Vietnamese translations for imaging parameter options
// This file provides Vietnamese translations for all the radio button and select options
// used in imaging forms while maintaining English values for data storage

export const IMAGING_OPTIONS_VI = {
  // Common options used across multiple parameters
  'Normal': 'Bình thường',
  'Abnormal': 'Bất thường',
  'Unable to assess': 'Không thể đánh giá',
  'Not assessed': 'Chưa đánh giá',
  'Not Assessed': 'Chưa đánh giá',
  'Indeterminate': 'Không xác định',
  'Present': 'Có',
  'Absent': 'Không có',
  'No': 'Không',
  'Yes': 'Có',
  'False': 'Không',
  'True': 'Có',
  'None': 'Không có',
  'Mild': 'Nhẹ',
  'Moderate': 'Vừa',
  'Severe': 'Nặng',
  'Small': 'Nhỏ',
  'Large': 'Lớn',
  'Normal (≤3mm)': 'Bình thường (≤3mm)',
  'Thickened (>3mm)': 'Dày (>3mm)',
  'Normal (≤4mm)': 'Bình thường (≤4mm)',
  'Thickened (>4mm)': 'Dày (>4mm)',

  // EKG specific options
  'Sinus': 'Nhịp xoang',
  'Atrial fibrillation': 'Rung nhĩ',
  'Atrial Flutter': 'Cuồng nhĩ',
  'Left axis deviation': 'Lệch trục trái',
  'Right axis deviation': 'Lệch trục phải',
  'Left ventricular hypertrophy': 'Phì đại thất trái',
  'Right ventricular hypertrophy': 'Phì đại thất phải',
  'RBBB': 'Blốc nhánh phải',
  'LBBB': 'Blốc nhánh trái',
  'First degree heart block': 'Blốc tim độ I',
  'Second degree heart block I': 'Blốc tim độ II loại I',
  'Second degree heart block II': 'Blốc tim độ II loại II',
  'Third degree heart block': 'Blốc tim độ III',
  'Depression': 'Chênh xuống',
  'Elevation': 'Chênh lên',
  'Inversion': 'Đảo ngược',
  'Peaked': 'Nhọn',
  'PAC': 'Ngoại tâm thu nhĩ',
  'PVC': 'Ngoại tâm thu thất',

  // Chest X-Ray specific options
  'Bilateral': 'Hai bên',
  'Unilateral Left': 'Một bên trái',
  'Unilateral Right': 'Một bên phải',
  'None Visualized': 'Không thấy',

  // Heart Ultrasound specific options
  'Hypokinetic': 'Giảm động',
  'Akinetic': 'Không động',
  'Dyskinetic': 'Vận động bất thường',
  'Mild regurgitation': 'Hở nhẹ',
  'Moderate regurgitation': 'Hở vừa',
  'Severe regurgitation': 'Hở nặng',
  'Stenosis': 'Hẹp',
  'Mildly enlarged': 'Giãn nhẹ',
  'Moderately enlarged': 'Giãn vừa',
  'Severely enlarged': 'Giãn nặng',

  // Thyroid Ultrasound specific options
  'Enlarged': 'To',
  'Small/Atrophic': 'Nhỏ/Teo',
  'Normal/Homogeneous': 'Bình thường/Đồng nhất',
  'Hypoechoic': 'Giảm âm',
  'Hyperechoic': 'Tăng âm',
  'Heterogeneous': 'Không đồng nhất',
  'No nodules': 'Không có nốt',
  '<1cm': '<1cm',
  '1-2cm': '1-2cm',
  '2-4cm': '2-4cm',
  '>4cm': '>4cm',
  'Solid': 'Đặc',
  'Cystic': 'Nang',
  'Mixed solid-cystic': 'Hỗn hợp đặc-nang',
  'Spongiform': 'Xốp',
  'Microcalcifications': 'Vôi hóa nhỏ',
  'Macrocalcifications': 'Vôi hóa lớn',
  'Rim calcifications': 'Vôi hóa viền',
  'Increased': 'Tăng',
  'Decreased': 'Giảm',
  'Suspicious features': 'Đặc điểm nghi ngờ',
  'TR1 (Benign)': 'TR1 (Lành tính)',
  'TR2 (Not suspicious)': 'TR2 (Không nghi ngờ)',
  'TR3 (Mildly suspicious)': 'TR3 (Nghi ngờ nhẹ)',
  'TR4 (Moderately suspicious)': 'TR4 (Nghi ngờ vừa)',
  'TR5 (Highly suspicious)': 'TR5 (Nghi ngờ cao)',
  'Not applicable': 'Không áp dụng',

  // Carotid Ultrasound specific options
  'Normal / No significant plaque or stenosis': 'Bình thường / Không có mảng xơ vữa hoặc hẹp đáng kể',
  'Mild plaque / Minimal stenosis (e.g., <50%)': 'Mảng xơ vữa nhẹ / Hẹp tối thiểu (ví dụ: <50%)',
  'Moderate stenosis (e.g., 50-69%)': 'Hẹp vừa (ví dụ: 50-69%)',
  'Severe stenosis (e.g., ≥70%)': 'Hẹp nặng (ví dụ: ≥70%)',
  'Near occlusion': 'Gần tắc hoàn toàn',
  'Total occlusion': 'Tắc hoàn toàn',
  'Unable to assess / Technically limited study': 'Không thể đánh giá / Nghiên cứu hạn chế kỹ thuật',
  'Normal CIMT (e.g., ≤ 0.9 mm)': 'CIMT bình thường (ví dụ: ≤ 0.9 mm)',
  'Increased CIMT (e.g., > 0.9 mm)': 'CIMT tăng (ví dụ: > 0.9 mm)',
  'Plaque present': 'Có mảng xơ vữa',
  'Unable to accurately assess / Technically limited': 'Không thể đánh giá chính xác / Hạn chế kỹ thuật',
  'Absent / Smooth or Irregular surface without ulceration': 'Không có / Bề mặt nhẵn hoặc không đều nhưng không loét',
  'Present / Ulceration identified': 'Có / Xác định loét',
  'Indeterminate / Unable to definitively assess surface for ulceration': 'Không xác định / Không thể đánh giá chắc chắn bề mặt có loét',
  'No significant calcification': 'Không vôi hóa đáng kể',
  'Minimal / Punctate calcification': 'Vôi hóa tối thiểu / Điểm',
  'Moderate / Patchy calcification': 'Vôi hóa vừa / Mảng',
  'Heavy / Confluent / Sheet-like calcification': 'Vôi hóa nặng / Liên tục / Dạng tấm',
  'Calcified nodule': 'Nốt vôi hóa',
  'Unable to assess pattern / Shadowing limits assessment': 'Không thể đánh giá mô hình / Bóng che hạn chế đánh giá',
  'Normal (<125 cm/s)': 'Bình thường (<125 cm/s)',
  'Elevated (125-230 cm/s)': 'Tăng (125-230 cm/s)',
  'Severely Elevated (>230 cm/s)': 'Tăng nặng (>230 cm/s)',
  'Low / Trickle Flow (Suspect Near Occlusion)': 'Thấp / Dòng chảy nhỏ giọt (Nghi ngờ gần tắc)',
  'No Flow (Occlusion)': 'Không dòng chảy (Tắc)',
  'Unable to assess / Technically limited': 'Không thể đánh giá / Hạn chế kỹ thuật',
  'Normal (<40 cm/s)': 'Bình thường (<40 cm/s)',
  'Elevated (40-100 cm/s)': 'Tăng (40-100 cm/s)',
  'Severely Elevated (>100 cm/s)': 'Tăng nặng (>100 cm/s)',
  'No Flow (Occlusion)': 'Không dòng chảy (Tắc)',
  'Vascular Age appropriate for Chronological Age': 'Tuổi mạch máu phù hợp với tuổi thực',
  'Vascular Age older than Chronological Age': 'Tuổi mạch máu lớn hơn tuổi thực',
  'Vascular Age younger than Chronological Age': 'Tuổi mạch máu nhỏ hơn tuổi thực',
  'Unable to determine / Data insufficient': 'Không thể xác định / Dữ liệu không đủ',

  // Spleen Ultrasound specific options
  'Normal spleen size': 'Kích thước lách bình thường',
  'Mild splenomegaly': 'To lách nhẹ',
  'Moderate splenomegaly': 'To lách vừa',
  'Massive splenomegaly': 'To lách nặng',
  'Smooth / No nodularity evident': 'Nhẵn / Không có nốt sần rõ ràng',
  'Solitary nodule noted': 'Ghi nhận nốt đơn độc',
  'Multiple nodules noted': 'Ghi nhận nhiều nốt',
  'Irregular / Diffusely nodular contour': 'Đường viền không đều / Nốt sần lan tỏa',
  'Normal / Homogeneous': 'Bình thường / Đồng nhất',
  'Hyperechoic (Diffusely Increased)': 'Tăng âm (Tăng lan tỏa)',
  'Hypoechoic (Diffusely Decreased)': 'Giảm âm (Giảm lan tỏa)',
  'No focal lesion identified': 'Không xác định tổn thương khu trú',
  'Lesion(s) present, largest < 1 cm': 'Có tổn thương, lớn nhất < 1 cm',
  'Lesion(s) present, largest 1-3 cm': 'Có tổn thương, lớn nhất 1-3 cm',
  'Lesion(s) present, largest > 3 cm': 'Có tổn thương, lớn nhất > 3 cm',
  'Lesion(s) present, size specified in notes': 'Có tổn thương, kích thước ghi trong ghi chú',
  'Normal diameter (e.g., ≤ 10 mm)': 'Đường kính bình thường (ví dụ: ≤ 10 mm)',
  'Dilated (e.g., > 10 mm)': 'Giãn (ví dụ: > 10 mm)',
  'Not well visualized / Measurement unreliable': 'Không thấy rõ / Đo không đáng tin cậy',
  'Normal / Low Risk of Esophageal Varices (PSDR > 909)': 'Bình thường / Nguy cơ thấp giãn tĩnh mạch thực quản (PSDR > 909)',
  'Increased Risk of Esophageal Varices (PSDR ≤ 909)': 'Tăng nguy cơ giãn tĩnh mạch thực quản (PSDR ≤ 909)',
  'Not Calculated / Components Unavailable': 'Không tính được / Thành phần không có sẵn',

  // Liver Ultrasound specific options
  'Normal liver span (e.g., ≤ 15.5 cm)': 'Kích thước gan bình thường (ví dụ: ≤ 15.5 cm)',
  'Mildly enlarged (Hepatomegaly, e.g., 15.6 - 18.0 cm)': 'To nhẹ (To gan, ví dụ: 15.6 - 18.0 cm)',
  'Moderately to Markedly enlarged (Hepatomegaly, e.g., > 18.0 cm)': 'To vừa đến rõ rệt (To gan, ví dụ: > 18.0 cm)',
  'Small liver size / Atrophic': 'Gan nhỏ / Teo',
  'Smooth / Regular contour': 'Đường viền nhẵn / Đều',
  'Irregular / Coarse contour': 'Đường viền không đều / Thô',
  'Micronodular contour': 'Đường viền nốt sần nhỏ',
  'Macronodular contour / Frank nodularity': 'Đường viền nốt sần lớn / Nốt sần rõ ràng',
  'Capsular retraction noted': 'Ghi nhận co kéo bao gan',
  'Normal echogenicity': 'Độ âm bình thường',
  'Mildly increased echogenicity (Steatosis Grade I)': 'Độ âm tăng nhẹ (Gan nhiễm mỡ độ I)',
  'Moderately increased echogenicity (Steatosis Grade II)': 'Độ âm tăng vừa (Gan nhiễm mỡ độ II)',
  'Severely increased echogenicity (Steatosis Grade III)': 'Độ âm tăng nặng (Gan nhiễm mỡ độ III)',
  'Coarse echotexture': 'Cấu trúc âm thô',
  'Other (specify in notes)': 'Khác (ghi rõ trong ghi chú)',
  'Normal diameter (e.g., ≤ 13 mm)': 'Đường kính bình thường (ví dụ: ≤ 13 mm)',
  'Dilated (e.g., > 13 mm)': 'Giãn (ví dụ: > 13 mm)',
  'US-1 (Negative)': 'US-1 (Âm tính)',
  'US-2 (Subthreshold)': 'US-2 (Dưới ngưỡng)',
  'US-3 (Positive)': 'US-3 (Dương tính)',
  'Lesion(s) present, largest < 10 mm': 'Có tổn thương, lớn nhất < 10 mm',
  'Lesion(s) present, largest ≥ 10 mm': 'Có tổn thương, lớn nhất ≥ 10 mm',
  'Triphasic (Normal)': 'Ba pha (Bình thường)',
  'Biphasic (Reduced phasicity)': 'Hai pha (Giảm tính pha)',
  'Monophasic (Flattened)': 'Một pha (Phẳng)',
  'Not adequately assessed / Technically limited': 'Không đánh giá đầy đủ / Hạn chế kỹ thuật',

  // Gallbladder Ultrasound specific options
  'Distended': 'Giãn',
  'Contracted': 'Co',

  // Kidney Ultrasound specific options
  'Hydronephrosis': 'Giãn bể thận'
};

/**
 * Get Vietnamese translation for an imaging parameter option
 * @param {string} option - The English option value
 * @returns {string} - Vietnamese translation or original if not found
 */
export const getImagingOptionTranslation = (option) => {
  return IMAGING_OPTIONS_VI[option] || option;
};

/**
 * Translate an array of options to Vietnamese
 * @param {Array} options - Array of English option values
 * @returns {Array} - Array of Vietnamese translations
 */
export const translateImagingOptions = (options) => {
  if (!Array.isArray(options)) return options;
  return options.map(option => getImagingOptionTranslation(option));
};

export default {
  IMAGING_OPTIONS_VI,
  getImagingOptionTranslation,
  translateImagingOptions
};
